import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-general-button',
    templateUrl: './general-button.component.html',
    styleUrls: ['./general-button.component.scss']
})
export class GeneralButtonComponent {

    /** Passed Proprieties for Custom use */
    @Input() text: string;
    // Text content of the button;

    @Input() icon: string;
    // Icon type (ex: Fonts Awesome 5.15.4);

    @Input() color: string | 'red' | 'blue' | 'yellow' | 'green' | 'black' | 'gray' | 'main' | 'tint-main' | 'table-general';
    // These are the general color types;

    @Input() textOnly: boolean | true | false;
    // This is used only if you want to remove the icon;

    /** Type */
    @Input() btnType: string | 'Short' | 'Long' | 'Table';
    // 'Long' - Contains Text + Icon at 40px Height and 24px padding left & right;
    // 'Short' - Contains only the icon at 40x40px;
    // 'Table' - Contains only icon at 32x32px;

    /** Style */
    @Input() btnStyle: string | 'Solid' | 'Outline' | 'Disabled';
    // 'Solid' - Full color button with a semi-transparent hover effect;
    // 'Outline' - Button with 1px border with color hover effect;
    // 'Disabled' - Button with "Not allowed" pointer on hover;

    /** Actions */
    @Input() btnAction: string | 'Add' | 'Save' | 'Edit' | 'Remove' | 'Back' | 'Close' | 'Cancel' | 'Custom';
    // The values above will create a default button of each type of usage. These are predefined;
    // Ex: 'Add' value will create an Add button with a suggestive icon next to the name;

    /** How to create a custom button */
    // Insert "<app-general-button></app-general-button>" into your html file and import the component;
    // The component should look like this:
    /**
     *  <app-general-button
     *      [btnStyle]="'Solid'"
     *      [btnType]="'Long'"
     *      [btnAction]="'Custom'"
     *      [textOnly]="false"
     *      [text]="'Back'"
     *      [icon]="'fa fa-arrow-left'"
     *      [color]="'red'"
     *      (click)="back()">
     *  </app-general-button>
     */
    // Set the [btnAction] to 'Custom'. Make sure you add the following props:
    // [text] - Only if you use the 'Long' type if buttons;
    // [icon] - Always add icons even if you don't need them;
    // [color] - Choose a color using [color] propriety;
    // [textOnly] - Set this to true only if you want to remove the icon from a 'Long' button type;

    constructor() {
    }
}


